import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { applySeo, setJsonLd } from "@/lib/seo";
import { getRouteSeo } from "@/lib/seo-data";

const MANAGED_SCHEMA_IDS = ["website", "organization", "breadcrumb", "article", "faq", "webpage"];

export default function SeoManager() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const lang = (i18n.language as "en" | "pt-BR" | "de") || "en";

  useEffect(() => {
    const { seo, schemas } = getRouteSeo(location.pathname, lang);

    applySeo(seo);

    const present = new Set(schemas.map((schema) => schema.id));
    MANAGED_SCHEMA_IDS.forEach((id) => {
      if (!present.has(id)) {
        setJsonLd(id, null);
      }
    });
    schemas.forEach((schema) => {
      setJsonLd(schema.id, schema.data);
    });
  }, [location.pathname, lang]);

  return null;
}